import React, { useEffect, useState } from "react";
import "./App.css";

function App() {
    const [fact, setFact] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("/facts.json")
            .then((response) => response.json())
            .then((data) => {
                console.log("Fakten sind mit LLM generiert. Keinen Anspruch auf Korrektheit")
                // Heutiges Datum im Format YYYY-MM-DD
                const today = new Date().toISOString().slice(0, 10);

                // Suche Fakt mit heutigem Datum, ignoriert dabei evtl. vorhandenen Zeit-Teil im JSON
                const todaysFact = data.find((item) =>
                    item.date.slice(0, 10) === today
                );

                setFact(
                    todaysFact
                        ? todaysFact.text
                        : "Kein Fakt für heute gefunden."
                );
            })
            .catch((err) => {
                console.error(err);
                setFact("Fehler beim Laden der Daten.");
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <div className="App">
            <header className="App-header">
                <h1>Täglicher Random Fakt</h1>
            </header>
            <div className="Fact-Box">
                {loading ? <p>Lade...</p> : <p>{fact}</p>}
            </div>
        </div>
    );
}

export default App;
